import { buildQuery } from '@/utils/helpers'
import fetcher from '../fetcher'

const GET_BLOG_CATEGORIES = `
query getBlogCategories {
    blogCategories {
      total_count
      items {
        breadcrumbs {
          category_id
          category_level
          category_name
          category_uid
          category_url_key
          category_url_path
        }
        canonical_url
        category_id
        category_level
        category_url
        category_url_path
        content
        content_heading
        custom_layout
        custom_layout_update_xml
        custom_theme
        custom_theme_from
        custom_theme_to
        display_mode
        identifier
        include_in_menu
        is_active
        layout_update_xml
        meta_description
        meta_keywords
        meta_title
        page_layout
        parent_category_id
        path
        position
        posts_count
        posts_sort_by
        title
        type
      }
    }
  }
`
const GET_BLOG_DETAIL = `
query getBlogDetail($id: String) {
    blogPost(id: $id) {
      author {
        author_id
        author_url
        content
        creation_time
        custom_layout
        custom_layout_update_xml
        custom_theme
        custom_theme_from
        custom_theme_to
        facebook_page_url
        featured_image
        filtered_content
        identifier
        instagram_page_url
        is_active
        layout_update_xml
        linkedin_page_url
        meta_description
        meta_title
        name
        page_layout
        relative_url
        role
        short_content
        short_filtered_content
        title
        twitter_page_url
        type
        url
      }
      author_id
      canonical_url
      categories {
        canonical_url
        category_id
        category_level
        category_url
        category_url_path
        content
        content_heading
        custom_layout
        custom_layout_update_xml
        custom_theme
        custom_theme_from
        custom_theme_to
        display_mode
        identifier
        include_in_menu
        is_active
        layout_update_xml
        meta_description
        meta_keywords
        meta_title
        page_layout
        parent_category_id
        path
        position
        posts_count
        posts_sort_by
        relative_url
        title
        type
      }
      category_id
      content_heading
      creation_time
      custom_layout
      custom_layout_update_xml
      custom_theme
      custom_theme_from
      custom_theme_to
      end_time
      featured_list_image
      featured_list_img_alt
      filtered_content
      first_image
      include_in_recent
      is_active
      is_recent_posts_skip
      layout_update_xml
      media_gallery {
        url
      }
      meta_description
      meta_keywords
      meta_title
      og_description
      og_image
      og_title
      og_type
      page_layout
      publish_time
      related_posts {
        ...BlogPostFields
      }
      relatedproduct_id
      relative_url
      search
      secret
      short_content
      short_filtered_content
      tag_id
      tags {
        content
        custom_layout
        custom_layout_update_xml
        custom_theme
        custom_theme_from
        custom_theme_to
        identifier
        is_active
        layout_update_xml
        meta_description
        meta_keywords
        meta_robots
        meta_title
        page_layout
        relative_url
        tag_id
        tag_url
        title
        type
      }
      type
      update_time
      views_count
      ...BlogPostFields
    }
  }fragment BlogPostFields on BlogPost {
    featured_image
    featured_img_alt
    identifier
    position
    post_id
    post_url
    title
  publish_time
   }`

const getBlogCategories = async () => {
  try {
    const response = await fetcher
      .get(buildQuery(GET_BLOG_CATEGORIES), {
        next: { revalidate: 120, tags: ['blog-categories'] },
      })
      .then((res) => res?.payload)

    const blogCategories: IBlogCategories = response?.data?.blogCategories
    if (!blogCategories) return { data: null, message: response?.errors?.[0]?.message, status: 'error' }
    return { data: blogCategories, status: 'success', message: 'Get blog categories successfully' }
  } catch (err) {
    console.log(err)
    return { data: null, message: JSON.stringify(err), status: 'error' }
  }
}

const getBlogDetail = async (id: string) => {
  try {
    const response = await fetcher
      .get(buildQuery(GET_BLOG_DETAIL, { id }), {
        next: { revalidate: 120, tags: ['blog-detail', id] },
      })
      .then((res) => res?.payload)

    const blogDetail: IBlogItemDetail = response?.data?.blogPost
    if (!blogDetail) return { data: null, message: response?.errors?.[0]?.message, status: 'error' }
    return { data: blogDetail, status: 'success', message: 'Get blog detail successfully' }
  } catch (err) {
    console.log(err)
    return { data: null, message: JSON.stringify(err), status: 'error' }
  }
}

export { getBlogCategories, getBlogDetail }
